import ServiceBase from "base/baseService"
import UfService from "business/cadastro/pessoa/uf/ufService"

export default class ListaUfService extends ServiceBase {

    title = "Lista de UF"
    pluralTitle = "Lista de UFs"
    url = '/cadastro/fiscal/listauf'
    frontUrl = '/cadastro/fiscal/listauf'
    frontUrlList = '/cadastro/fiscal/listauflist'
    primaryKey = 'codigo_liuf'
    ignoredsSchemaConvertions = ['usu_atua_liuf', 'cod_liuf_ufli']

    prepareToFront(data = {}) {

        console.log('DATA: ', data)

        data.descricao_liuf = data?.descricao_liuf || ''

        data.lista_uf_item = (data?.lista_uf_item || []).map(item => {
            const uf = item?.uf
            const formattedUf = uf
                ? this.formatUfOption(uf.codigo_uf, uf.sigla_uf, uf.descricao_uf)
                : this.formatUfOption(item?.cod_uf_ufli, item?.sigla_uf, item?.descricao_uf)

            return {
                action: 'none',
                ...item,
                uf: formattedUf
            }
        })

        return data
    }

    prepareToSave({ data }) {

        const parentCodigo = data?.codigo_liuf || null
        const validActions = ['ins', 'upd', 'del']
        const listaUfItem = (data.lista_uf_item || [])
            .filter(item => validActions.includes(item?.action))
            .map(item => {
                const formatted = { ...item }
                formatted.cod_uf_ufli = item?.uf?.codigo_uf || item?.cod_uf_ufli || null
                formatted.cod_liuf_ufli = item?.cod_liuf_ufli || parentCodigo
                delete formatted.uf
                return formatted
            })

        data.lista_uf_item = listaUfItem
        delete data.uf_busca

        return data
    }

    getNewListaUfItem(data = {}) {
        return {
            action: 'ins',
            cod_uf_ufli: null,
            cod_liuf_ufli: null,
            uf: null,
            ...data
        }
    }

    formatUfOption = (codigo_uf, sigla_uf, descricao_uf) => {
        if (!codigo_uf) return null

        return {
            codigo_uf,
            sigla_uf: sigla_uf || '',
            descricao_uf: descricao_uf || '',
            descricao_sigla: sigla_uf && descricao_uf ? `${sigla_uf} - ${descricao_uf}` : (sigla_uf || descricao_uf || '')
        }
    }

    async listUfOptions() {
        const ufService = new UfService()
        return ufService.list('?page=1&perPage=60&sort=sigla_uf')
    }

}
